import { render, staticRenderFns } from "./DashboardAuthorizationCard.html?vue&type=template&id=32167b46&scoped=true&"
import script from "./DashboardAuthorizationCard.js?vue&type=script&lang=js&"
export * from "./DashboardAuthorizationCard.js?vue&type=script&lang=js&"
import style0 from "./DashboardAuthorizationCard.scss?vue&type=style&index=0&id=32167b46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32167b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow,VSkeletonLoader})
